import { put, takeEvery, select } from 'redux-saga/effects'
import { Api, Game } from '../../Core'

import * as surveyActions from './survey.actions'
import * as savePointActions from '../SavePoint/savePoint.actions'
import * as savePointSelectors from '../SavePoint/savePoint.selectors'
import * as FirebaseSelectors from '../../Core/Firebase/firebase.selectors'
import * as indicatorSelectors from '../Indicators/indicators.selectors'

import SurveyViewer from './SurveyViewer'

/**
 *  Load survey components
 */
export function* loadComponents() {
  const components = {
    SurveyViewer,
  }
  yield put(Game.actions.registerComponents(components))
}
/**
 *  Load components
 */
export function* init() {
  yield loadComponents()
}
/**
 * Send
 */
export function* sendSurvey(action) {
  const survey = action.data
  try {
    const successed = yield Api.post('/games-core/survey', {}, survey)
    yield put(savePointActions.completeSurvey())
    yield put(savePointActions.toggleSurvey())
    yield put(surveyActions.addOkResponse(true))
    yield put(Game.actions.removeScreen('survey'))
    const game = yield select(Game.selectors.getGame)
    yield put(savePointActions.syncWithGame(game))
    yield put(savePointActions.startSave())

    if (!successed) {
      throw new Error('')
    }
  } catch (e) {
    yield put(surveyActions.addErrorResponse(true))
    if (e && e.status === 401) {
      console.log('Unauthorized')
      yield put(Game.actions.returnToPlatform())
    }
  }
}

export function* loadSurvey() {
  const groupData = yield select(FirebaseSelectors.getGroupData)
  const userData = yield select(indicatorSelectors.getUserData)
  const isSurveyCompleted = yield select(savePointSelectors.isSurveyCompleted)

  const canDisplaySurvey =
    groupData.session === groupData.sessions && userData.turn % groupData.maxTurns === 0

  if (canDisplaySurvey && !(isSurveyCompleted || isSurveyCompleted == undefined)) {
    yield put(Game.actions.addScreen('survey'))
  }
}

/**
 *  Surveys sagas entrypoint
 */
export function* sagas() {
  yield takeEvery(Game.actions.INIT, init)
  yield takeEvery(surveyActions.LOAD_SURVEY, loadSurvey)
  yield takeEvery(surveyActions.SEND_SURVEY, sendSurvey)
}
